module.exports = __webpack_public_path__ + "img/73027d6.png";